<!-- 按钮 -->
<template>
  <el-button type="text" >
    <span v-if="typeClass" class="cp" :class="typeClass"><slot></slot></span>
    <template v-else="">
      <slot></slot>
    </template>
  </el-button>
</template>

<script>
  export default {
    props:{
      typeClass:{
        value:String,
        default:""
      }
    },
    name: 'b-button',
    data () {
      return {}
    },
    mixins: [tableBase],
    methods: {

    },
    mounted () {
    }
  }
</script>

<style lang="less" scoped>
  .el-button{
    color: #0071ef;
    padding: 0 8px 0 0;
  }
  .el-button+.el-button{
    margin-left: 0 !important;
  }
</style>
